export const capitalize = (str) => str && str.replace(/\b\w/g, (l) => l.toUpperCase());
export const lowerAndCapitalize = (str) => capitalize(str.toLowerCase());
export const removeUnderscores = (str) => str && str.replace(/_/g, " ");
export const pwdCheck = (str) => {
  if (str.length < 8) {
    return "too short";
  } else if (str.length > 50) {
    return "too long";
  } else if (str.search(/\d/) == -1) {
    return "must contain at least a number";
  } else if (str.search(/[a-zA-Z]/) == -1) {
    return "must contain at least a charcter";
  } //else if (str.search(/[^a-zA-Z0-9\!\@\#\$\%\^\&\*\(\)\_\+]/) != -1) {
  //   return 'bad_char'
  // }
  return false;
};
export const encodeEmailUrl = (email) => {
  return encodeURIComponent(email);
};

export const decodeEmailUrl = (encodedEmail) => {
  return decodeURIComponent(encodedEmail);
};

export const priceFormat = (value) => {
  if (!value) return null;

  const format = (value) => value.toLocaleString("IT-it", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  if (typeof value === "string") {
    return format(Number.parseFloat(value));
  }

  return format(value);
};
